// extracted by mini-css-extract-plugin
export var button = "button_button__SOKBP";
export var disabledSecondary = "button_disabledSecondary__776C6";
export var outline = "button_outline__laF46";
export var primary = "button_primary__PXFEL";